import { Image } from "antd";
import axios from "axios";
import { create } from "zustand";

export let usePosts = create((set, get) => ({
    posts: [],
    columns: [
        {
            title: "ID",
            dataIndex: "id",
            key: "id",
            width: 50,
        },
        {
            title: "Asosiy rasm",
            dataIndex: "img",
            key: "img",
            render: (img) => <Image src={img} style={{ width: "50px" }} />,
            width: 100,
        },
        {
            title: "Sarlavha",
            dataIndex: "title",
            key: "title",
        },
        {
            title: "Kategoriya",
            dataIndex: "category",
            key: "category",
        },
        {
            title: 'Maqola Fayli',
            dataIndex: 'pdf',
            key: 'pdf',
            render: (_, rec)=>(rec.pdf) ? <a href={rec.pdf} target="_blank">Yuklash yoki ko'rish</a> : "Fayl mavjud emas"
        },
        {
            title: "Joylangan sana",
            dataIndex: "created_at",
            key: "created_at",
        },

    ],
    ed: {},
    setEd: (ed) => set({ ed }),
    setPosts: () => {
        axios.get('/posts')
            .then((res) => {
                const posts = Array.isArray(res.data) ? res.data : [];
                set({ posts });
            })
            .catch((err) => {
                console.error('Maqolalarni yuklab olishda xatolik:', err);
                set({ posts: [] });
            })
    },
    addPost: (post) => {
        axios.post('/posts', post)
            .then((res) => {
                get().setPosts();
            })
            .catch((err) => {
                console.error('Maqola qo\'shishda xatolik:', err);
            })
    },
    editPost: (post) => {
        axios.put('/posts/' + post.id, post)
            .then((res) => {
                get().setPosts();
            })
            .catch((err) => {
                console.error('Maqolani taxrirlashda xatolik:', err);
            })
    },
    deletePost: (id) => {
        axios.delete('/posts/' + id)
            .then((res) => {
                get().setPosts();
            })
            .catch((err) => {
                console.error('Maqolani o\'chirishda xatolik:', err);
            })
    },
    getPost: (id) => set((state) => ({ currentPost: state.posts.find((p) => p.id === id) })),
    clearPosts: () => set({ posts: [] })
}));